import React from 'react';
import clsx from 'clsx';
import styles from './ExpandableRowCellRenderer.module.scss';
import { caretRight } from '../../../../../../assets/hostedassets';
import { CellRendererProps } from '../../../DataTable.types';

export const ExpandableRowCellRenderer: React.FC<CellRendererProps> = ({ row, dynamicProps }) => {
    const { isCollapsed, toggleCollapse } = dynamicProps || {};

    if (!row.investorDeals) return null;

    return (
        <div
            className={clsx(styles.CaretDiv, {
                [styles.CaretDivHov]: !isCollapsed,
            })}
            onClick={(e) => {
                e.stopPropagation();
                toggleCollapse?.(row);
            }}
        >
            <img
                className={clsx(styles.CaretImg, {
                    [styles.ExpandedCaret]: !isCollapsed,
                })}
                src={caretRight}
                alt="Dropdown"
                height="14px"
                style={{ marginTop: '4px' }}
            />
        </div>
    );
};

export default ExpandableRowCellRenderer;
